export default __webpack_public_path__ + "static/tiny-58825d83f038cdd5d042956cef2e1502.png";